// extracted by mini-css-extract-plugin
export default {"container":"SingleAsset_container__Ng1HG","contributors":"SingleAsset_contributors__Udo5A","sidebar":"SingleAsset_sidebar__A2t8B","sidebarInfo":"SingleAsset_sidebarInfo__lg1e9"};